import { api } from '@cwd/lib/main';

export async function getValidatedEmail(email: string): Promise<{ IsValidated: boolean }> {
    return api.get('/ValidatedEmails/' + email + '/');
}

export async function sendReplyAddressValidation(email: string): Promise<void> {
    return api.post('/Accounts/Current/SendEmailValidation', email);
}
